import { render } from "./displayValue.vue?vue&type=template&id=3c2bd4e4&scoped=true"
import script from "./displayValue.vue?vue&type=script&lang=js"
export * from "./displayValue.vue?vue&type=script&lang=js"

import "./displayValue.vue?vue&type=style&index=0&id=3c2bd4e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2bd4e4"]])

export default __exports__